var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1298_23685"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "message-chat-circle",
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "message-chat-circle",
    width: 24,
    height: 24,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1298_23685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.8223 17.9072C13.2236 17.9683 13.6348 18 14.0527 18C15.0527 18 16.0098 17.8191 16.8926 17.488C17.082 17.4172 17.1768 17.3818 17.251 17.3662C17.3242 17.3508 17.376 17.3452 17.4512 17.3447C17.5273 17.3442 17.6104 17.3564 17.7764 17.3809L20.9619 17.8479C21.3145 17.8997 21.4912 17.9253 21.6211 17.8694C21.7354 17.8206 21.8262 17.731 21.8779 17.6182C21.9375 17.4895 21.915 17.3125 21.8721 16.9585L21.4688 13.6882C21.4492 13.5271 21.4395 13.4465 21.4414 13.3735C21.4424 13.301 21.4492 13.2512 21.4648 13.1804C21.4805 13.1089 21.5156 13.0176 21.585 12.8345C21.9209 11.9534 22.1055 10.998 22.1055 10C22.1055 5.58179 18.5 2 14.0527 2C9.60547 2 6 5.58179 6 10C6 10.418 6.03223 10.8281 6.09473 11.2288M13 16.5C13 13.4624 10.5967 11 7.63184 11C4.66699 11 2.2627 13.4624 2.2627 16.5C2.2627 17.1106 2.36035 17.698 2.53906 18.2468C2.61523 18.4788 2.65332 18.5947 2.66602 18.6738C2.67871 18.7566 2.68066 18.8032 2.67578 18.8867C2.67188 18.9668 2.65137 19.0574 2.61133 19.2383L2 22L4.99512 21.5911C5.1582 21.5686 5.24023 21.5576 5.31152 21.5581C5.38672 21.5586 5.42676 21.5625 5.5 21.5771C5.57031 21.5913 5.67383 21.6279 5.88184 21.7014C6.43066 21.895 7.01953 22 7.63184 22C10.5967 22 13 19.5376 13 16.5Z",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/ic_chat.c72d5f93c2d07b78e3e76e604b0dda78.svg";
export { ForwardRef as ReactComponent };